.u{width:100%;}